import { useCallback, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { selectIsMapInitialized } from '../../store/map/map.selectors'

/*
 * useCompass gets phone orientation angle relative to north.
 * This allows to turn the the geolocation marker according the current user direction.
 *
 * Current code work on Android with Chrome & Firefox.
 *
 * It could work on iOS but we should ask permission via DeviceOrientationEvent.requestPermission on iOS 13+
 *
 * Useful links :
 *  - https://dev.to/orkhanjafarovr/real-compass-on-mobile-browsers-with-javascript-3emi
 *  - https://caniuse.com/?search=deviceorientationabsolute
 *  - https://dev.to/li/how-to-requestpermission-for-devicemotion-and-deviceorientation-events-in-ios-13-46g2
 */
export function useCompass(activated) {
  const mapInitialized = useSelector(selectIsMapInitialized)
  const [rotation, setRotation] = useState(0)

  const compassHandler = useCallback(e => {
    if (!e.absolute) return
    setRotation(-(e.alpha || 0).toFixed(0))
  }, [])

  useEffect(() => {
    if (mapInitialized && activated) {
      const eventName = 'deviceorientationabsolute'
      window.addEventListener(eventName, compassHandler, true)
      return () => {
        window.removeEventListener(eventName, compassHandler)
      }
    }
  }, [mapInitialized, activated, compassHandler])
  return rotation
}
